<template>
  <h1 class="page-title mb-2">
    <slot></slot>
  </h1>
</template>

<script>
export default {};
</script>

<style scoped>
.page-title {
  font-size: 24px;
}
</style>
